'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Label": "Polaris-Label",
  "hidden": "Polaris-Label--hidden",
  "Text": "Polaris-Label__Text",
  "RequiredIndicator": "Polaris-Label__RequiredIndicator"
};

exports.default = styles;
